module.exports = __webpack_public_path__ + "img/file_type_ppt.8e3e678.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AISmart/file_type_ppt.png
// module id = HuuS
// module chunks = 12 13 14 17 26